
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import * as moment from 'moment';

export class GenSyncUser {

    approved: boolean;
    contractor: boolean;
    department: string;
    email: string;
    emailVerified: boolean;
    enabled: boolean;
    expirationDate: moment.Moment;
    firstName: string;
    idpEmail: string;
    joinDate: moment.Moment;
    lastName: string;
    organization: string;
    originatingSystem: string;
    phone: string;
    pkiSubject: string;
    requestReason: string;
    roles: string[];
    subOrganization: string;
    subscribed: boolean;
    username: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genSyncUser: GenSyncUser);

    constructor( input?: GenSyncUser ) {
        if ( input && typeof input !== 'number' ) {
            this.approved = input.approved; // boolean [boolean]
            this.contractor = input.contractor; // boolean [boolean]
            this.department = input.department; // string [string]
            this.email = input.email; // string [string]
            this.emailVerified = input.emailVerified; // boolean [boolean]
            this.enabled = input.enabled; // boolean [boolean]
            if ( input.expirationDate && typeof input.expirationDate === 'string' ) {
                this.expirationDate = moment(input.expirationDate).utc();
            } else {
                this.expirationDate = input.expirationDate;
            }
            this.firstName = input.firstName; // string [string]
            this.idpEmail = input.idpEmail; // string [string]
            if ( input.joinDate && typeof input.joinDate === 'string' ) {
                this.joinDate = moment(input.joinDate).utc();
            } else {
                this.joinDate = input.joinDate;
            }
            this.lastName = input.lastName; // string [string]
            this.organization = input.organization; // string [string]
            this.originatingSystem = input.originatingSystem; // string [string]
            this.phone = input.phone; // string [string]
            this.pkiSubject = input.pkiSubject; // string [string]
            this.requestReason = input.requestReason; // string [string]
            this.roles = input.roles; // list [string]
            this.subOrganization = input.subOrganization; // string [string]
            this.subscribed = input.subscribed; // boolean [boolean]
            this.username = input.username; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenSyncUser[] {
        if (arr && arr.map) {
          return arr.map(a => new GenSyncUser(a));
        } else {
          return [];
        }
    }
}

